import SliderManager from "./SliderManager.js";

const reviewsSlider = new SliderManager({
  selector: ".reviews__list",
  splideOptions: {
    label: "Отзывы клиентов",
    type: "loop",
    perPage: 1,
    perMove: 1,
    pagination: true,
    arrows: true,
    fixedWidth: "380px",
    trimSpace: false,
    updateOnMove: true,
    waitForTransition: true,
    gap: "32px",
    mediaQuery: "min",
    breakpoints: {
      768: {
        perPage: 2,
        perMove: 2,
      },
      1280: {
        perPage: 3,
        perMove: 3,
      },
    },
  },
  globalVarName: "reviewsSlider",
  resizeDelay: 250,
  dynamicWrapper: {
    trackClass: "reviews__slider-track",
    itemClass: "reviews__item",
  },
});

reviewsSlider.init();
